import type { Item } from 'components/SelectItem/types';

type IdAndName = { id?: string; name?: string };

export const parseToItems = <T extends IdAndName>(items: T[]): Item[] =>
    items.map(({ id = '', name = '' }) => ({
        label: name,
        value: id
    }));

export const parseToItemsWithKeys = <T extends IdAndName, K extends keyof T>(
    items: T[],
    keys: K[]
): (Item & Pick<T, K>)[] =>
    items.map(
        item =>
            ({
                label: item.name ?? '',
                value: item.id ?? '',
                ...Object.fromEntries(keys.map(key => [key, item[key]]))
            }) as Item & Pick<T, K>
    );
